import { render, staticRenderFns } from "./TopOffice.vue?vue&type=template&id=07af286d"
import script from "./TopOffice.vue?vue&type=script&lang=js"
export * from "./TopOffice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports